import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import { i18n } from './i18n.js'
import BootstrapVue from 'bootstrap-vue'
import './custom.scss'
import Vuelidate from 'vuelidate'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
